module.exports = __webpack_public_path__ + "img/6521.06c00c51.jpg";